module.exports = __webpack_public_path__ + "icon.babfaae5d3c4e6b2f19037b51794f108.svg";